import { Status, CallAPIAction } from 'api/types'
import Actions from 'redux/actions'

type State = {
  errorMessage: string
} & Status

type FailResponse = {
  error?: {
    message?: string
  }
}

const initialState: State = {
  errorMessage: '',
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.DISABLE_LISTING_REQUEST_ASYNC,
    Actions.DISABLE_LISTING_REQUEST_SUCCESS,
    Actions.DISABLE_LISTING_REQUEST_FAIL,
    {},
    FailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.DISABLE_LISTING_REQUEST_ASYNC:
    case Actions.DISABLE_LISTING_REQUEST_SUCCESS:
      return {
        ...state,
        ...action.status,
      }

    case Actions.DISABLE_LISTING_REQUEST_FAIL:
      return {
        ...state,
        ...action.status,
        errorMessage: action.payload?.error?.message || '',
      }
    default:
      return state
  }
}
